import React from 'react';
import anime from 'animejs'

import './intro.css';

const BASE_ANIMATION_TIMING = 1500;

const Intro = () => {
    console.log(anime.running)
    return (
        <div className='intro-container' style={{ opacity: 1, scale: 1 }} ref={(ref) => {
            anime({
                targets: ref,
                delay: BASE_ANIMATION_TIMING * 2,
                opacity: 0,
                duration: BASE_ANIMATION_TIMING,
                easing: 'easeInOutSine'
            })
            anime({
                targets: ref,
                scale: 0,
                delay: BASE_ANIMATION_TIMING * 2.5,
                duration: BASE_ANIMATION_TIMING,
                easing: 'easeInOutSine'
            })
        }}>
            <span style={{ transform: 'translateX(0)' }}
                ref={(ref) => anime({
                    targets: ref,
                    translateX: '-2000px',
                    delay: BASE_ANIMATION_TIMING * 0.8,
                    duration: BASE_ANIMATION_TIMING,
                    easing: 'easeInOutSine'
                })}>Learn</span>
            <span
                style={{ transform: 'translateY(0)' }}
                ref={(ref) => anime({
                    targets: ref,
                    translateY: '-2000px',
                    delay: BASE_ANIMATION_TIMING * 1.25,
                    duration: BASE_ANIMATION_TIMING,
                    easing: 'easeInOutSine'
                })}>Progress</span>
            <span
                style={{ transform: 'translateX(0)' }}
                ref={(ref) => anime({
                    targets: ref,
                    translateX: '2000px',
                    delay: BASE_ANIMATION_TIMING * 1.5,
                    duration: BASE_ANIMATION_TIMING,
                    easing: 'easeInOutSine'
                })}>Innovate</span>
        </div>
    );
};

export default Intro;